module.exports = __webpack_public_path__ + "img/Activate Link.71fb66a8.jpg";